export const SET_MUI_GROUPING_STATUS = "SET_MUI_GROUPING_STATUS"

export const setMuiGroupingStatus = (action) => ({
  type: SET_MUI_GROUPING_STATUS,
  json: action
})
